import React from 'react'
import { View } from 'react-native'
import { createContainer } from '@dbk-legacy/muster/react';
import PriceHistoryChart from './price-history-chart'
import { LoadingCircle } from '../../../../../../../src/components/common/loading'

class PriceHistoryChartContainer extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      ready: false
    }
  }

  async componentDidMount() {
    this.setState({ ready: false })
    const num_days = 30;
    const { positionCurrency: psCcy, subAssetsDesc, number, ricCode } = this.props.row
    if (subAssetsDesc) {
      await this.props.priceHistory.getData({
        psActNmb: number,
        subAssetsDesc,
        ricCode,
        psCcy,
        num_days
      })
 
    } else await this.props.priceHistory.getData()
    this.setState({ ready: true })
  }

  render() {
    const {
      priceHistory: { data },
      row,
      row: { subAssetsDesc },
      selectedInteractionValue,
      onInteractionChange,
      screen,
      currency,
      messages,
      yValue
    } = this.props
    if (!subAssetsDesc) return null
    if (!this.state.ready) return <LoadingCircle />
    if (!data) return null

    const priceHistory = JSON.parse(data).map(({ psMktPrc, psAvaBal, psMktPrcDte, asOfDate }) => ({
      price: { value: psMktPrc || psAvaBal || null },
      date: psMktPrcDte || asOfDate || null,
      formattedDate: psMktPrcDte || asOfDate || null,
    }))
    return (
      <div tabIndex={data?"0":"-1"}>
        <PriceHistoryChart
          row={row}
          currency={currency}
          height={250}
          data={priceHistory}
          width={600}
          selectedInteractionValue={selectedInteractionValue}
          onInteractionChange={onInteractionChange}
          screen={screen}
          messages={messages}
          yValue={yValue}
        />
      </div>
    )
  }
}

// export default Discovery
export default createContainer({
  $queries: {
    priceHistory: {
      getData: { $call: 'getData' },
      data: true,
    },
  }
})(PriceHistoryChartContainer)
